import { ErrorState, RegistrationPaymentData } from 'types';

export const CREATE_PAYMENT_METHOD_START = 'CREATE_PAYMENT_METHOD_START';
export const CREATE_PAYMENT_METHOD_COMPLETED = 'CREATE_PAYMENT_METHOD_COMPLETED';
export const CREATE_PAYMENT_METHOD_ERROR = 'CREATE_PAYMENT_METHOD_ERROR';

export const UPDATE_PAYMENT_METHOD_START = 'UPDATE_PAYMENT_METHOD_START';
export const UPDATE_PAYMENT_METHOD_COMPLETED = 'UPDATE_PAYMENT_METHOD_COMPLETED';
export const UPDATE_PAYMENT_METHOD_ERROR = 'UPDATE_PAYMENT_METHOD_ERROR';


export const createPaymentMethod = (cardDetails: RegistrationPaymentData) => {
    return {
        type: CREATE_PAYMENT_METHOD_START,
        payload: {
            cardDetails,
        }
    };
};

export const createPaymentMethodCompleted = () => {
    return {
        type: CREATE_PAYMENT_METHOD_COMPLETED,
        payload: {},
    };
};

export const createPaymentMethodError = (error: ErrorState) => {
    return {
        type: CREATE_PAYMENT_METHOD_ERROR,
        error: error,
        payload: {},
    };
};

//=======================================================================

export const updatePaymentMethod = (cardDetails: any) => {
    return {
        type: UPDATE_PAYMENT_METHOD_START,
        payload: {
            cardDetails,
        },
    };
};

export const updatePaymentMethodCompleted = () => {
    return {
        type: UPDATE_PAYMENT_METHOD_COMPLETED,
        payload: {},
    };
};

export const updatePaymentMethodError = (error: ErrorState) => {
    return {
        type: UPDATE_PAYMENT_METHOD_ERROR,
        error: error,
        payload: {},
    };
};
